

import { defineStore } from 'pinia'
import reportApi from '@/services/reportAPI'
import { ref } from 'vue'

export const useReportStore = defineStore('report', {
  state: () => ({
    evReportIsEmpty: ref(false),
    evReport: ref([]),
    pressureReportIsEmpty: ref(false),
    pressureReport: ref([]),
    groupedDataDaily: ref([]),
    groupedDataWeekly: ref([]),
    groupedDataMonthly: ref([]),
    reportData: ref([]),
    totalData: ref(),
    isLoading: ref(false),
    status: ref({
      message: null,
      code: null,
    }),
    evReportStatus: ref({
      message: null,
      code: null,
      isError: false,
    }),
    pressureReportStatus: ref({
      message: null,
      code: null,
      isError: false,
    }),
  }),
  actions: {
    async loadReport() {
      this.isLoading = true
      try {
        const res = await reportApi.getReport()
        this.reportData = res.data
        this.totalData = res.data.length
        this.isLoading = false
      } catch (err) {
        console.error(err)
        this.isLoading = false
        return err
      }
    },
    async loadEvReport(params) {
      this.isLoading = true
      try {
        const res = await reportApi.getEvReport(params)
        if (res.data.data.ev.groupedDataDaily.length === 0) {
          this.evReportIsEmpty = true
        } else {
          this.evReportIsEmpty = false
        }
        this.evReport = res.data.data.ev
        this.groupedDataDaily = res.data.data.ev.groupedDataDaily
        this.groupedDataWeekly = res.data.data.ev.groupedDataWeekly
        this.groupedDataMonthly = res.data.data.ev.groupedDataMonthly
        this.isLoading = false
        this.evReportStatus.message = 'Data Fetched'
        this.evReportStatus.isError = false
      } catch (err) {
        console.error(err)
        this.evReportStatus.message = err.response.data.error
        this.evReportStatus.isError = true
        this.isLoading = false
        return err
      }
    },
    async loadPressureReport(params,  signal = null) {
      this.isLoading = true
      try {
        const res = await reportApi.getPressureReport(params, signal)
        console.log(res)
        this.pressureReport = res.data.data
        if (res.data.data.length === 0) {
          this.pressureReportIsEmpty = true
        } else {
          this.pressureReportIsEmpty = false
        }
        this.isLoading = false
        this.pressureReportStatus.message = 'Data Fetched'
        this.pressureReportStatus.isError = false
      } catch (err) {
        console.error(err)
        this.pressureReportStatus.message = err.response.data.error
        this.pressureReportStatus.isError = true
        this.isLoading = false
        return err
      }
    },
    async downloadEvReport(params) {
      this.isLoading = true
      try {
        const res = await reportApi.downloadEvReport(params)
        window.open(res.request.responseURL)

        this.isLoading = false
      } catch (err) {
        console.error(err)
        this.isLoading = false
        return err
      }
    },
  }
})